// Design mode: which properties of a standard set / column an organization may
// change (`tenant_may`, the transaction designer's own keys verbatim). Each
// chip is one key of the vocabulary uda/model.py allows for that kind of item.

import { Building2 } from 'lucide-react'

export default function TenantMayChips({ value, vocabulary, labels, onChange, what }: {
  value: string[]
  vocabulary: readonly string[]
  labels?: Record<string, string>
  onChange: (v: string[]) => void
  what: string
}) {
  const on = new Set(value.map(v => String(v).toLowerCase()))
  const toggle = (k: string) => {
    const next = on.has(k) ? value.filter(v => String(v).toLowerCase() !== k) : [...value, k]
    onChange(next)
  }
  return (
    <div className="uds-pcard">
      <div className="uds-pcard-h"><Building2 size={14} /><span className="uds-grow">Organizations may change</span></div>
      <div className="uds-pcard-b">
        <div className="uds-hint" style={{ marginTop: 0, marginBottom: 8 }}>
          Ticked properties of {what} can be changed by an organization in Customize. Everything else stays as you set it.
        </div>
        <div className="uds-chips">
          {vocabulary.map(k => (
            <button key={k} type="button" className={`uds-vchip ${on.has(k) ? 'on' : ''}`} aria-pressed={on.has(k)}
              onClick={() => toggle(k)} title={k}>
              {labels?.[k] || k}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
